import { render } from "./SellersRanking.vue?vue&type=template&id=c791b924"
import script from "./SellersRanking.vue?vue&type=script&lang=js"
export * from "./SellersRanking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__